// ModalLayout.jsx
import {
  useLocation,
  useNavigate,
  Outlet,
  Routes,
  Route,
  matchPath,
} from "react-router-dom";
import { useEffect } from "react";
import { isMobile } from "react-device-detect";

import {
  ProtectedRoute,
  ProtectedRouteLogin,
} from "../component/ProctectedRoute";

import Login from "../component/Login";
import Register from "../component/Register";
import ForgotPassword from "./ForgotPassword";
import ResetPassword from "./Account/ResetPassword";
import Message from "./Account/Message";
import BettingHistory from "./Account/BettingHistory";
import TransactionRecords from "./Account/TransactionRecords";
import Profile from "./Account/Profile";
import Refrel from "./Account/Refrel";

import Listing from "./9wicket/Listing";
import MatchDetail from "./matchDetail/MatchDetail";
import Casino from "./Casino";
import { getDecodedToken } from "../Utils/Toast";
import AccountStatementDefault from "./Account/AccountStatement";
import Terms from "./Terms";
import Promotions from "./Promotions";
import Deposit from "./Account/Deposit";
import AffiliateLink from "../component/AffiliateLink";
import Home from "./Home";
import DailyStreakChallenge from "./Account/DailyStreakChallenge";
import FreeSpin from "./Account/FreeSpin";
import RealTimeBonus from "./Account/RealTimeBonus";
import WinnerBoard from "./Account/WinnerBoard";

const MODAL_CONFIG = {
  "/login": { component: Login, wrapper: ProtectedRoute },
  "/register": { component: Register, wrapper: ProtectedRoute },
  "/forgot-password": { component: ForgotPassword, wrapper: ProtectedRoute },
  "/reset-password": {
    component: ResetPassword,
    wrapper: ProtectedRouteLogin,
  },
  "/promotions": { component: Promotions },
  "/message": { component: Message },
  "/terms/:type": {
    component: Terms,
  },
  "/betting-history": {
    component: BettingHistory,
    wrapper: ProtectedRouteLogin,
  },

  "/transaction-records": {
    component: TransactionRecords,
    wrapper: ProtectedRouteLogin,
  },
  "/account-statement": {
    component: AccountStatementDefault,
    wrapper: ProtectedRouteLogin,
  },
  "/wallet/:type": { component: Deposit, wrapper: ProtectedRouteLogin },
  "/daily-streak-challenge": {
    component: DailyStreakChallenge,
    wrapper: ProtectedRouteLogin,
  },

  "/winner-board": {
    component: WinnerBoard,
    wrapper: ProtectedRouteLogin,
  },
  "/real-time-bonus": {
    component: RealTimeBonus,
    wrapper: ProtectedRouteLogin,
  },
  // "/free-spin": {
  //   component: FreeSpin,
  //   wrapper: ProtectedRouteLogin,
  // },

  "/wallet/:type/:offerCode": {
    component: Deposit,
    wrapper: ProtectedRouteLogin,
  },
  "/affiliate-link": { component: AffiliateLink, wrapper: ProtectedRouteLogin },
  "/profile": { component: Profile, wrapper: ProtectedRouteLogin },
  "/refrel": { component: Refrel, wrapper: ProtectedRouteLogin },
};

export default function ModalLayout() {
  const findModalConfig = (pathname) => {
    for (const [pattern, config] of Object.entries(MODAL_CONFIG)) {
      const match = matchPath({ path: pattern, end: true }, pathname);
      if (match) return { config, match };
    }
    return null;
  };

  const location = useLocation();
  const navigate = useNavigate();

  const background = location.state?.background;
  const pathname = location.pathname;

  // ✅ Persist background to sessionStorage when it exists
  useEffect(() => {
    if (background) {
      sessionStorage.setItem("modalBackground", JSON.stringify(background));
    }
  }, [background]);

  // ✅ On refresh, restore from sessionStorage
  const restoredBackground =
    background ||
    (() => {
      const stored = sessionStorage.getItem("modalBackground");
      return stored ? JSON.parse(stored) : null;
    })();

  const canShowModal = !!restoredBackground && !isMobile;
  const modalMatch = findModalConfig(pathname);
  const modalConfig = modalMatch?.config;

  const isAnyModal = canShowModal && modalConfig;

  useEffect(() => {
    const match = findModalConfig(pathname);
    // ✅ Only redirect if no background AND no stored background
    const stored = sessionStorage.getItem("modalBackground");
    if (match && !background && !stored && !isMobile) {
      navigate(-1, { replace: true });
    }
  }, [pathname, background, navigate]);

  const renderModal = () => {
    if (!canShowModal || !modalConfig) return null;

    const ModalComponent = modalConfig.component;
    const Wrapper = modalConfig.wrapper;

    return Wrapper ? (
      <Wrapper>
        <ModalComponent />
      </Wrapper>
    ) : (
      <ModalComponent />
    );
  };

  return (
    <>
      {isAnyModal ? (
        <Routes location={restoredBackground}>
          <Route path="/" element={<Home />} />
          <Route path="/casino" element={<Casino />} />
          <Route
            path="/match-detail/:eventId/:marketId"
            element={<MatchDetail />}
          />{" "}
          <Route
            path="/match-detail/:eventId/:marketId/:type"
            element={<MatchDetail />}
          />
        </Routes>
      ) : (
        <Outlet />
      )}
      {renderModal()}
    </>
  );
}
